import { useInfiniteQuery } from '@tanstack/react-query';

import type { Car } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = {
  text?: string;
};

type ListedCarsPage = {
  data: Car[];
  meta: {
    page: number;
    totalPages: number;
    totalCount: number;
  };
};

const fetchListedCars = async ({
  pageParam,
  variables,
}: {
  pageParam: number;
  variables: Variables;
}) => {
  try {
    let params: Record<string, any> = {
      page: pageParam,
    };

    if (variables.text) {
      params.text = variables.text;
    }

    const response = await client.get('v2/internal/partners/cars/listed', {
      params: { ...params },
    });

    return response.data;
  } catch (error) {
    console.error('fetchListedCars error:', error);
    throw error;
  }
};

export const useListedCars = (variables: Variables) => {
  return useInfiniteQuery({
    queryKey: ['internal/partners/cars/listed', variables],
    queryFn: ({ pageParam = 1 }) =>
      fetchListedCars({
        pageParam,
        variables,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: ListedCarsPage) => {
      if (lastPage.meta.page >= lastPage.meta.totalPages) {
        return undefined;
      }
      return lastPage.meta.page + 1;
    },
  });
};
